/*
 * Koebsbjaelken i bunden af produktsiden.
 *
 * Den viser sig naar den rigtige koebsknap er rullet forbi, og den ejer ingen
 * tilstand selv: klik sendes videre til knappen i formularen, og titel, pris
 * og variantnavn spejles derfra. Saadan kan Canopy skifte variant uden at vi
 * skal holde noget i sync.
 */
(function () {
  'use strict';

  var bjaelke = document.querySelector('.nt-koebsbjaelke');
  if (!bjaelke) return;

  var knap = bjaelke.querySelector('.nt-koebsbjaelke__knap');
  var prisFelt = bjaelke.querySelector('.nt-koebsbjaelke__pris');
  var variantFelt = bjaelke.querySelector('.nt-koebsbjaelke__variant');

  function rigtigKnap() {
    return document.querySelector('.product-info__add-button button[name="add"]');
  }

  /* Prisen staar i infokolonnen. Vi tager kun selve beloebet: ikke den
     overstregede foer-pris, ikke enhedsprisen, og ikke de skjulte etiketter
     som skaermlaesere faar ("Salgspris", "Enhedspris"). */
  function laesPris() {
    var felt = document.querySelector('.product-info__price .price__current') ||
               document.querySelector('.product-info__price .price');
    if (!felt) return '';
    var klon = felt.cloneNode(true);
    klon.querySelectorAll('.visually-hidden, .unit-price, .price__unit, [class*="unit-price"]')
        .forEach(function (e) { e.remove(); });
    return klon.textContent.replace(/\s+/g, ' ').trim();
  }

  function laesVariant() {
    var valgt = document.querySelector('.product-info .opt-btn:checked');
    if (!valgt) return '';
    var etiket = valgt.nextElementSibling;
    return etiket ? etiket.textContent.trim() : '';
  }

  function opdater() {
    var original = rigtigKnap();
    if (!original) return;
    if (prisFelt) prisFelt.textContent = laesPris();
    if (variantFelt) variantFelt.textContent = laesVariant();
    if (knap) {
      knap.textContent = original.textContent.trim();
      knap.disabled = original.disabled;
    }
  }

  if (knap) {
    knap.addEventListener('click', function () {
      var original = rigtigKnap();
      if (original && !original.disabled) original.click();
    });
  }

  /* Canopy skriver hele infoblokken om ved variantskift, saa vi lytter bredt
     paa produktkortet frem for paa enkelte noder der bliver skiftet ud. */
  var info = document.querySelector('.product-info');
  if (info && window.MutationObserver) {
    var venter = false;
    new MutationObserver(function () {
      if (venter) return;
      venter = true;
      requestAnimationFrame(function () {
        venter = false;
        opdater();
      });
    }).observe(info, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-info')) opdater();
  });

  /* Vis bjaelken naar koebsknappen er rullet OP forbi toppen. Er den stadig
     under folden (foerste visning), skal bjaelken ikke daekke siden.

     Vi laeser positionen paa hvert frame under rulning frem for at stole paa
     IntersectionObserver: ved et spring i rulningen (anker, tilbage-knap)
     fyrer den med et foraeldet udsnit, og bjaelken blev haengende skjult.
     Én rect-laesning pr. frame er billig nok. */
  var maal = rigtigKnap();
  if (!maal) return;
  opdater();

  var venterRul = false;
  function vurder() {
    venterRul = false;
    var r = maal.getBoundingClientRect();
    var ude = r.bottom < 0;
    if (ude === !bjaelke.hidden) return;
    bjaelke.hidden = !ude;
    if (ude) bjaelke.classList.add('nt-koebsbjaelke--inde');
  }
  function paaRul() {
    if (venterRul) return;
    venterRul = true;
    requestAnimationFrame(vurder);
  }
  window.addEventListener('scroll', paaRul, { passive: true });
  window.addEventListener('resize', paaRul, { passive: true });
  vurder();
})();
